// src/components/SkillCategory.js
import React from "react";
import SkillCard from "./SkillCard";  // Ensure correct path

const SkillCategory = ({ category, skills }) => {
  return (
    <div className="skill-category">
      <h3 className="skill-category-title">{category}</h3>
      <div className="skills-list">
        {skills.map((skill) => (
          <SkillCard key={skill.id} skill={skill} />
        ))}
      </div>
    </div>
  );
};

export default SkillCategory;
